// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/main.scss
// module id = 37
// module chunks = 0